// Copyright (c) 2016 Deere & Company

import View from './view';
import t from 'tcomb';

const Views = t.list(View, 'Views');

export const getDefaultState = () =>
    new Views([
        {
            columns: [
                {
                    key: 'pin',
                    value: 'PIN'
                },
                {
                    key: 'description',
                    value: 'Description'
                },
                {
                    key: 'model',
                    value: 'Model'
                },
                {
                    key: 'account',
                    value: 'Dealer Account'
                },
                {
                    key: 'name',
                    value: 'Dealer Name'
                },
                {
                    key: 'location',
                    value: 'Dealer Location'
                },
                {
                    key: 'invoiceDate',
                    value: 'Invoice Date'
                },
                {
                    key: 'currentAmountOfUse',
                    value: 'Current Amount Of Use'
                },
                {
                    key: 'unit',
                    value: 'Unit'
                },
                {
                    key: 'exceedsDemoThreshold',
                    value: 'Exceeds Demo Threshold'
                },
                {
                    key: 'accumulatedDaysOnRent',
                    value: 'Accumulated Days on Rent'
                },
                {
                    key: 'currentlyOnRent',
                    value: 'Currently On Rent'
                },
                {
                    key: 'estimatedBasicDays',
                    value: 'Estimated Basic Days'
                },
                {
                    key: 'estimatedBasicDate',
                    value: 'Estimated Basic Date'
                },
                {
                    key: 'reportDate',
                    value: 'Report Date'
                }

            ],
            name: 'standard view',
            sortBy: [
                {
                    key: 'estimatedBasicDate',
                    order: 'DESC',
                    value: 'Estimated Basic Date'
                }
            ]
        }
    ]);

export default Views;



// WEBPACK FOOTER //
// ./src/reports/basic-warranty-estimator/state/views.js